import { Injectable, inject } from "@angular/core";
import { IframeMessagesService } from "../iframe-messages-service/iframe-messages.service";
import { ResponseErrorHandlerService } from "../response-error-handler-service/response-error-handler.service";
import { type Member } from "../../card-modal-component/member-interface";

interface IPortalInfo {
    id: number;
    portalName: string | null;
    portalId: number;
    contactExists: boolean;
}

export interface IPortalInfoRequestPayload {
    documentId: string;
    contactId: number;
}

@Injectable({ providedIn: "root" })
export class iFirmPortalService {
    private iframeMessagesService = inject(IframeMessagesService);
    private readonly responseErrorHandlerService = inject(ResponseErrorHandlerService);

    iFirmPortalInfos: IPortalInfo[] = [];

    private async getiFirmPortalInfos(payload: IPortalInfoRequestPayload[]): Promise<IPortalInfo[]> {
        try {
            const result = await this.iframeMessagesService.postMessageResp("getiFirmPortalInfos", { payload: payload }, "gotiFirmPortalInfos");
            if (result.status === "success") {
                this.iFirmPortalInfos = result.portalInfos as IPortalInfo[];
                return this.iFirmPortalInfos;
            }
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        } catch (error) {
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        }
        return [];
    }

    public async getiFirmPortalId(
        documentId: string,
        activeTaxPayerContactId: string,
        activeTaxPayerMemberType: string,
        mainTaxpayerContactId: string,
    ): Promise<number | undefined> {
        if (!activeTaxPayerContactId || !activeTaxPayerMemberType) return;
        const payload: IPortalInfoRequestPayload[] = [
            { documentId: documentId, contactId: Number(activeTaxPayerContactId) },
            ...(activeTaxPayerMemberType !== "Taxpayer" && mainTaxpayerContactId
                ? [
                      {
                          documentId: documentId,
                          contactId: Number(mainTaxpayerContactId),
                      },
                  ]
                : []),
        ];

        const portalInfos = await this.getiFirmPortalInfos(payload);
        if (!portalInfos || portalInfos.length === 0) return;

        const portalId = (
            portalInfos.find(({ id }) => id === Number(activeTaxPayerContactId)) ??
            portalInfos.find(({ id }) => mainTaxpayerContactId && id === Number(mainTaxpayerContactId))
        )?.portalId;

        return portalId;
    }

    public async getiFirmDocument(productType: string, documentId: string): Promise<number | undefined> {
        try {
            const result = await this.iframeMessagesService.postMessageResp("getDocument", { payload: { productType, documentId } }, "gotDocument");
            if (result.status === "success") return result.response?.year;
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        } catch (error) {
            this.responseErrorHandlerService.showPopup({
                typeLayout: "ERROR",
                messageCode: "defaultError",
            });
        }
        return;
    }
}
